import React from 'react';

const Introduction: React.FC = () => {
  return (
    <div>
      <h1>Introduction</h1>
    </div>
  );
}

export default Introduction;